var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 16.6447H14.75V15.3026H8.25V16.6447ZM8.25 13.0658H14.75V11.7237H8.25V13.0658ZM6.56672 20C6.12891 20 5.75833 19.8434 5.455 19.5303C5.15167 19.2171 5 18.8345 5 18.3825V4.61746C5 4.16547 5.15167 3.78289 5.455 3.46974C5.75833 3.15658 6.12891 3 6.56672 3H13.45L18 7.69737V18.3825C18 18.8345 17.8483 19.2171 17.545 19.5303C17.2417 19.8434 16.8711 20 16.4333 20H6.56672ZM12.8 8.36842V4.34211H6.56672C6.49998 4.34211 6.43888 4.37081 6.38342 4.42822C6.32781 4.48549 6.3 4.54857 6.3 4.61746V18.3825C6.3 18.4514 6.32781 18.5145 6.38342 18.5718C6.43888 18.6292 6.49998 18.6579 6.56672 18.6579H16.4333C16.5 18.6579 16.5611 18.6292 16.6166 18.5718C16.6722 18.5145 16.7 18.4514 16.7 18.3825V8.36842H12.8Z",
    fill: "#71839B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportInactive);
export default __webpack_public_path__ + "static/media/report-inactive.f391f768a0532ad7a9066df77e569eb6.svg";
export { ForwardRef as ReactComponent };